














































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import moment from 'moment';
import {IService} from '../shared/services/models/Service';
import {IExternalIPAddress, ISetting} from '../shared/services/models/Setting';
import {IBoroSettings} from '../shared/services/models/BoroSettings';
import {IServer} from '../shared/services/models/Server';

import APIService from '../services/api';
import { numeric } from 'vee-validate/dist/rules';

@Component({
    components: {
        // @ts-ignore
        CopyrightComponent : require('@/components/Copyright').default,
    },
    computed: {
        ...mapState(['services', 'settings', 'boroSettings', 'serverStatus', 'commandStatus', 'commandLastId', 'commandStatusMTR', 'commandLastIdMTR']),
    },
    methods: {
        ...mapActions(['updateServices', 'enableService', 'disableService', 'startService', 'stopService', 'updateSettings', 'saveSetting', 'updateBoroSettings', 'saveBoroSettings', 'executeCommand', 'checkCommandStatus', 'checkCommandStatusMTR', 'reboot']),
    },
})
export default class About extends Vue {
    private services!: IService[];
    private settings!: ISetting[];
    private boroSettings!: IBoroSettings;
    private serverStatus!: IServer;


    private newCinegyRouteAddress: string|null = null;
    private newCinegyRoutePort: string|null = null;

    private newBoroName: string|null = null;
    private newBoroId: string|null = null;
    private newBoroDescription: string|null = null;
    private newBoroUrl: string|null = null;
    private newBoroProxy: string|null = null;
    private newBoroKey: string|null = null;

    private PingAddress: string = '';
    private PingStatus: string = 'Ping';
    private PingNIC: string|null = null;
    private PingInterval: any = -1;

    private MTRAddress: string = '';
    private MTRStatus: string = 'Trace';
    private MTRNIC: string|null = null;
    private MTRInterval: any = -1;

    private PingResult: any[] = [];
    private MTRResult: any[] = [];

    private serviceUpdaterHandle: any = null;

    private ListViewDetailsValue: string = '';
    private StatisticsKeepDurationValue: string = '';
    private ToastModeValue: string = 'all';

    private CinegyAddressKey: string = 'cinegy.route.multicast.address';
    private CinegyPortKey: string = 'cinegy.route.multicast.port';

    private DefaultListenPortKey: string = 'streaming.listner.default.port';
    private DefaultInputListenPortKey: string = 'streaming.listner.default.inputport';

    private ListViewDetailsKey: string = 'ui.interfaces.details.mode';

    private StatisticsKeepDurationKey: string = 'statistics.keep.duration';
    private ExternalIPKey: string = 'server.external_ip';

    private StickyBarKey: string = 'ui.titlebar.sticky';
    private TitleKey: string = 'ui.titlebar.title';

    private ZixiDeviceIdKey: string = 'zixi.device.id';

    private ToastKey: string = 'ui.toast';

    private StatisticsKeepDaysKey: string = 'statistics.keep.days';

    private PacketBunchingKey: string = 'streaming.packet.bunch.size';

    private ZixiZenHostKey: string = 'streaming.zixi.zen.host';
    private ZixiZenUsernameKey: string = 'streaming.zixi.zen.username';
    private ZixiZenGUIPortKey: string = 'streaming.zixi.zen.gui.port';
    private ZixiZenSSHPortKey: string = 'streaming.zixi.zen.ssh.port';
    private ZixiZenCertPrivateKey: string = 'streaming.zixi.zen.certificate.private';
    private ZixiZenCertPubliceKey: string = 'streaming.zixi.zen.certificate.public';

    private DefaultNICKey: string = 'server.default_nic';
    private ExternalIPListKey: string = 'server.external_ip_list';
    private AllwaysShowNICBindingsKey: string = 'server.nic_bindings_show';

    private mounted() {
        // @ts-ignore
        this.updateSettings();
        // @ts-ignore
        this.updateServices();
        // @ts-ignore
        this.updateBoroSettings();

        setTimeout(() => {
            this.ListViewDetailsValue = this.ListViewDetails;
            this.StatisticsKeepDurationValue = this.StatisticsKeepDuration;
            this.ToastModeValue = this.ToastMode;
        }, 1500);

        this.serviceUpdaterHandle = setInterval(() => {
            // @ts-ignore
            this.updateServices();
        }, 2500);
    }

    private unmounted() {
        if (this.serviceUpdaterHandle !== null) {
            clearInterval(this.serviceUpdaterHandle);
            this.serviceUpdaterHandle = null;
        }
    }

    private get Settings(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};

        if (this.settings) {
            this.settings.forEach((s) => {
                ret[s.key] = s.value;
            });
        }

        return ret;
    }

    private get Services(): IService[] {
        if (this.services) {
            return this.services.sort((l: IService, r: IService): number => {
                const lService: string = this.getServiceName(l);
                const rService: string = this.getServiceName(r);

                if (lService < rService) {
                    return -1;
                } else if (lService > rService) {
                    return 1;
                }

                return 0;
            });
        }

        return [];
    }

    private get NetworkDevicesLocal(): { [key: string]: string } {
            if (this.serverStatus) {
                return this.serverStatus.address;
            }

            return {};
        }

    private get NetworkDevices(): any[] {
        const ret: any[] = [];

        ret.push({
            text: 'auto',
            value: '',
        });

        Object.keys(this.NetworkDevicesLocal).forEach((n) => {
            ret.push({
                text: `${n} (${this.NetworkDevicesLocal[n]})`,
                value: n,
            });
        });

        return ret;
    }

    private get NetworkDevicesTools(): any[] {
        const ret: any[] = [];
        ret.push({
            text: 'Please select a NIC',
            value: null,
        });
        Object.keys(this.NetworkDevicesLocal).forEach((n) => {
            if (n.toLowerCase() !== 'lo') {
                ret.push({
                    text: `${n} (${this.NetworkDevicesLocal[n]})`,
                    value: n,
                });
            }
        });

        return ret;
    }

      private get NetworkDevicesToolsMTR(): any[] {
        const ret: any[] = [];
        ret.push({
            text: 'Please select a NIC',
            value: null,
        });
        Object.keys(this.NetworkDevicesLocal).forEach((n) => {
            if (n.toLowerCase() !== 'lo') {
                ret.push({
                    text: `${n} (${this.NetworkDevicesLocal[n]})`,
                    value: this.NetworkDevicesLocal[n],
                });
            }
        });

        return ret;
    }

    private get Started(): string {
        const now = moment();
        return now.subtract(this.serverStatus.uptime, 'seconds').format('YYYY-MM-DD HH:mm:ss');
    }

    private get Uptime(): string {
        const now = moment();
        return now.subtract(this.serverStatus.uptime, 'seconds').fromNow();
    }

    private get StatisticsKeepDuration(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.StatisticsKeepDurationKey)) {
            return s[this.StatisticsKeepDurationKey];
        }

        return '600';
    }

    private get StickyBar(): boolean {
        const s = this.Settings;

        if (s.hasOwnProperty(this.StickyBarKey)) {
            return s[this.StickyBarKey] === 'true';
        }

        return false;
    }

    private get BarTitle(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.TitleKey)) {
            return s[this.TitleKey];
        }

        return 'Stream Manager';
    }

    private get CinegyRouteAddress(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.CinegyAddressKey)) {
            return s[this.CinegyAddressKey];
        }

        return '';
    }

    private get CinegyRoutePort(): number {
        const s = this.Settings;

        if (s.hasOwnProperty(this.CinegyPortKey)) {
            try {
                return parseInt(s[this.CinegyPortKey], 10);
            } catch (E) { /* nothing to do */}
        }

        return 0;
    }

    private get DefaultListenPort(): number {
        const s = this.Settings;

        if (s.hasOwnProperty(this.DefaultListenPortKey)) {
            try {
                return parseInt(s[this.DefaultListenPortKey], 10);
            } catch (E) { /* nothing to do */}
        }

        return 0;
    }

    private get DefaultInputListenPort(): number {
        const s = this.Settings;

        if (s.hasOwnProperty(this.DefaultInputListenPortKey)) {
            try {
                return parseInt(s[this.DefaultInputListenPortKey], 10);
            } catch (E) { /* nothing to do */}
        }

        return 0;
    }

    private get ListViewDetails(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.ListViewDetailsKey)) {
            return s[this.ListViewDetailsKey];
        }

        return '';
    }

     private get ExternalIP(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.ExternalIPKey)) {
            return s[this.ExternalIPKey];
        }

        return '';
    }

    private serviceStatus(service: IService) {
        return moment(service.timestamp + 'Z').from(moment(service.now.replace('+00', 'Z')));
        return service.timestamp;
    }

    private externalNicAddressChanged(newValue: string, nic: string) {
        const s = this.Settings;

        let currentSettings: { [key: string]: string } = {};
        if (s.hasOwnProperty(this.ExternalIPListKey)) {
            currentSettings = JSON.parse(s[this.ExternalIPListKey]);
            if (Array.isArray(currentSettings)) {
                currentSettings = {};
            }
            currentSettings[nic] = newValue;

            this.globalSettingChanged(JSON.stringify(currentSettings), this.ExternalIPListKey);
        }
    }

    private get ExternalIPList(): IExternalIPAddress[]/*: { [key: string]: string }*/ {
        const s = this.Settings;
        const ret: IExternalIPAddress[] = []; // { [key: string]: string } = {};

        let currentSettings: {[key: string]: string } = {};
        if (s.hasOwnProperty(this.ExternalIPListKey)) {
            currentSettings = JSON.parse(s[this.ExternalIPListKey]);
        }

        this.NetworkDevices.forEach((nic) => {
            if (nic.value !== 'lo' && nic.value !== '') {
                ret.push({
                    id: nic.value,
                    name: nic.text,
                    value: currentSettings.hasOwnProperty(nic.value) ? currentSettings[nic.value] : '',
                });
            }
        });

        return ret;
    }

    private get BoroProjectName(): string {
        if (this.boroSettings) {
            return this.boroSettings.name;
        }

        return '';
    }

    private get BoroProjectId(): string {
        if (this.boroSettings) {
            return this.boroSettings.id;
        }

        return '';
    }

    private get BoroDescription(): string {
        if (this.boroSettings) {
            return this.boroSettings.description;
        }

        return '';
    }

    private get BoroURL(): string {
        if (this.boroSettings) {
            return this.boroSettings.url;
        }

        return '';
    }

    private get BoroProxy(): string {
        if (this.boroSettings && this.boroSettings.proxy) {
            return this.boroSettings.proxy;
        }

        return '';
    }

    private get BoroKey(): string {
        if (this.boroSettings) {
            return this.boroSettings.key;
        }

        return '';
    }

    private get ToastMode(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.ToastKey)) {
            return s[this.ToastKey];
        }

        return 'all';
    }

    private get ZixiDeviceId(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.ZixiDeviceIdKey)) {
            return s[this.ZixiDeviceIdKey];
        }

        return '';
    }

    private get StatisticsKeepDays(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.StatisticsKeepDaysKey)) {
            return s[this.StatisticsKeepDaysKey];
        }

        return '2';
    }

    private get PacketBunching(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.PacketBunchingKey)) {
            return s[this.PacketBunchingKey];
        }

        return '2';
    }

    private get ZixiZenUsername(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.ZixiZenUsernameKey)) {
            return s[this.ZixiZenUsernameKey];
        }

        return 'username';
    }

    private get ZixiZenHost(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.ZixiZenHostKey)) {
            return s[this.ZixiZenHostKey];
        }

        return 'host';
    }

    private get ZixiZenGUIPort(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.ZixiZenGUIPortKey)) {
            return s[this.ZixiZenGUIPortKey];
        }

        return '8080';
    }

    private get ZixiZenSSHPort(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.ZixiZenSSHPortKey)) {
            return s[this.ZixiZenSSHPortKey];
        }

        return '22';
    }

    private getServiceStatusByName(serviceName: string): boolean {
        let ret: boolean = false;
        if (this.services) {
            this.services.forEach((s) => {
                if (s.service === serviceName) {
                    ret = this.getServiceStatus(s);
                }
            });
        }

        return ret;
    }

    private getServiceStatus(service: IService): boolean {
        if (service && service.status && service.status.toLowerCase() === 'active') {
            return true;
        }

        return false;
    }

    private getServiceState(service: IService): boolean {
        if (service && service.state && service.state.toLowerCase() === 'enabled') {
            return true;
        }

        return false;
    }

    private executePing(): void {
        if (this.PingStatus === 'Ping') {
            this.PingStatus = 'Pinging...';
            // @ts-ignore
            this.executeCommand({command: 'ping', address: this.PingAddress, nic: this.PingNIC});
            if (this.PingInterval === -1) {
                this.PingInterval = setInterval(async () => {
                    // @ts-ignore
                    await this.checkCommandStatus(this.commandLastId);
                    // @ts-ignore
                    if (!Array.isArray(this.commandStatus) ) {
                        clearInterval(this.PingInterval);
                        this.PingInterval = -1;
                        this.PingStatus = 'Show Result';
                    }
                }, 500);
            }
        } else if (this.PingStatus === 'Show Result') {
            // @ts-ignore
            const pingData = this.commandStatus.output;
            const pingLines = pingData.split(/\r?\n/);
            let i = 0;
            const pingResult: any[] = [];
            for (const line of pingLines) {
                if (i === 0) {
                    // header
                } else if (line.startsWith('---')) {
                    // do nothing
                } else if (line.startsWith('rtt')) {
                    // do nothing right now
                } else if (line.includes('packets transmitted')) {
                    // do nothing right now
                } else if (line.length === 0) {
                    // empty string
                } else {
                    // rest
                    const items: string[] = line.split(' ');
                    // tslint:disable:prefer-const
                    let result: any = { };
                    // tslint:enable
                    for (const l of items) {

                        if (l.includes('=')) {
                            // this is where the data we need is
                            const values: string[] = l.split('=');
                            if (l.length > 1) {
                                result[values[0]] = values[1];
                            }
                        } else if (l.toLowerCase() === 'Unreachable') {
                            // do something
                            result.error = 'Unreachable';
                            break;
                        }
                    }
                    pingResult.push(result);
                }
                i++;
            }
            this.PingResult = pingResult;
            // @ts-ignore
            this.$bvModal.show('modal-ping-result');
            // alert(pingData);
        }
    }

    private clearPing(): void {
        this.PingStatus = 'Ping';
        if (this.PingInterval !== -1) {
            clearInterval(this.PingInterval);
            this.PingInterval = -1;

        }
    }

    private executeMTR(): void {
        if (this.MTRStatus === 'Trace') {
            this.MTRStatus = 'Tracing...';
            // @ts-ignore
            this.executeCommand({command: 'tracert', address: this.MTRAddress, nic: this.MTRNIC});
            if (this.MTRInterval === -1) {
                this.MTRInterval = setInterval(async () => {
                    // @ts-ignore
                    await this.checkCommandStatusMTR(this.commandLastIdMTR);
                    // @ts-ignore
                    if (!Array.isArray(this.commandStatusMTR) ) {
                        clearInterval(this.MTRInterval);
                        this.MTRInterval = -1;
                        this.MTRStatus = 'Show Result';
                    }
                }, 500);
            }
        } else if (this.MTRStatus === 'Show Result') {
            // @ts-ignore
            const pingData = JSON.parse(this.commandStatusMTR.output);
            this.MTRResult = pingData.report.hubs;
            // @ts-ignore
            this.$bvModal.show('modal-mtr-result');
            // alert(pingData);
        }
    }

    private clearMTR(): void {
        this.MTRStatus = 'Trace';
        if (this.MTRInterval !== -1) {
            clearInterval(this.MTRInterval);
            this.MTRInterval = -1;
        }
    }

    private getServiceActions(service: IService): string[] {
        if (service && service.service) {
            switch (service.service) {
                case 'bt_streaming_start.service'   : return ['enable'];
                case 'cinegy_route_updater.timer'   : return ['enable', 'start'];
                case 'bt_clear_stats.timer'         : return ['enable', 'start'];
                case 'boro.service'                 : return ['enable', 'start'];
                case 'ondemand.service'             : return ['enable'];
                case 'bt_server_status.service'     : return ['enable', 'start'];
                case 'bt_rp_off.service'            : return ['enable'];
                case 'bt_network_buffers.service'   : return ['enable'];
                case 'bt_interface_monitor.service' : return ['monitor'];
                case 'bt_interface_control.service' : return ['monitor'];
                default                             : return [];
            }
        }

        return [];
    }

    private getServiceName(service: IService): string {
        if (service && service.service) {
            switch (service.service) {
                case 'bt_streaming_start.service'   : return 'Autostart interfaces at boot';
                case 'cinegy_route_updater.timer'   : return 'Automatic update of UI router destinations';
                case 'bt_clear_stats.timer'         : return 'Automatically clear old stats';
                case 'boro.service'                 : return 'IP Probe';
                case 'ondemand.service'             : return 'CPU Governor OnDemand (should be disabled)';
                case 'bt_server_status.service'     : return 'Fetch current server status';
                case 'bt_rp_off.service'            : return 'Reverse Path filtering Off';
                case 'bt_network_buffers.service'   : return 'Network buffers';
                case 'bt_interface_monitor.service' : return 'Interface status';
                case 'bt_interface_control.service' : return 'Interface control';
                default                             : return service.service;
            }
        }

        return '';
    }

    private cinegyAddressChanged(value: string): void {
        this.newCinegyRouteAddress = value;
    }

    private cinegyPortChanged(value: string): void {
        this.newCinegyRoutePort = value;
    }

    private globalSettingChanged(value: string, key: string) {
        // @ts-ignore
        this.saveSetting({ key, value });
        // @ts-ignore
        Vue.set(this.settings, key, value);
    }

    private settingChanged(value: string, key: string) {
         Vue.set(this, key, value);
    }

    private saveCinegyRouteSettings(): void {
        if (this.newCinegyRouteAddress !== null) {
            // @ts-ignore
            this.saveSetting({ key: this.CinegyAddressKey, value :  this.newCinegyRouteAddress });

            this.newCinegyRouteAddress = null;
        }

        if (this.newCinegyRoutePort !== null) {
            // @ts-ignore
            this.saveSetting({ key: this.CinegyPortKey, value :  this.newCinegyRoutePort });

            this.newCinegyRoutePort = null;
        }
    }

    private saveProbeSettings(): void {
        const settings: IBoroSettings = {
            name: this.BoroProjectName,
            id: this.BoroProjectId,
            description: this.BoroDescription,
            url: this.BoroURL,
            proxy: this.BoroProxy,
            key: this.BoroKey,
        };

        if (this.newBoroName !== null) {
            settings.name = this.newBoroName;
        }

        if (this.newBoroId !== null) {
            settings.id = this.newBoroId;
        }

        if (this.newBoroDescription !== null) {
            settings.description = this.newBoroDescription;
        }

        if (this.newBoroUrl !== null) {
            settings.url = this.newBoroUrl;
        }

        if (this.newBoroProxy !== null) {
            settings.proxy = this.newBoroProxy;
        }

        if (this.newBoroKey !== null) {
            settings.key = this.newBoroKey;
        }

        // @ts-ignore
        this.saveBoroSettings(settings);
    }

    private get DefaultNIC(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.DefaultNICKey)) {
            return s[this.DefaultNICKey];
        }

        return '';
    }

    private get ShowNICBindings(): boolean {
        const s = this.Settings;

        if (s.hasOwnProperty(this.AllwaysShowNICBindingsKey)) {
            return s[this.AllwaysShowNICBindingsKey].toLowerCase() === 'true';
        }

        return false;
    }

    private rebootServer(): void {
        this.$bvModal.msgBoxConfirm('Please confirm that you want reboot the server.', {
          title: 'Confirm server reboot',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        }).then((value) => {
          if (value) {
              window.console.log('Reboot server confirmed');
              // @ts-ignore
              this.reboot();
          }
        }).catch((err) => {
            // An error occurred
        });
    }

    private enableDisableService(value: any, service: string): void {
        if (value) {
            // @ts-ignore
            this.enableService(service);
        } else {
            // @ts-ignore
            this.disableService(service);
        }
    }

    private startStopService(value: any, service: string): void {
        if (value) {
            // @ts-ignore
            this.startService(service); // uses same backend code
        } else {
            // @ts-ignore
            this.stopService(service); // uses same backend code
        }
    }

    private toggleStickyBar(value: any): void {
        if (value) {
            // @ts-ignore
            this.saveSetting({ key: this.StickyBarKey, value : 'true' });
        } else {
            // @ts-ignore
            this.saveSetting({ key: this.StickyBarKey, value : 'false' });
        }
    }

    private toggleShowNICCindings(value: any): void {
        if (value) {
            // @ts-ignore
            this.saveSetting({ key: this.AllwaysShowNICBindingsKey, value : 'true' });
        } else {
            // @ts-ignore
            this.saveSetting({ key: this.AllwaysShowNICBindingsKey, value : 'false' });
        }
    }

    private saveTitle(value: string) {
        // @ts-ignore
        this.saveSetting({ key: this.TitleKey, value });
    }

}

